(function(){
  'use strict';
  var root=document.querySelector('[data-rn-home]');
  if(!root)return;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var loader=root.querySelector('[data-rn-loader]');
  var loaderRings=root.querySelector('[data-rn-loader-rings]');
  var nav=root.querySelector('[data-rn-nav]');
  var progress=root.querySelector('[data-rn-progress]');
  var menu=root.querySelector('[data-rn-menu]');
  var openButton=root.querySelector('[data-rn-menu-open]');
  var closeButton=root.querySelector('[data-rn-menu-close]');
  var menuLastFocus=null;
  var heroImage=root.querySelector('[data-rn-hero-image]');
  var heroVideo=root.querySelector('[data-rn-hero-video]');
  var carousel=root.querySelector('[data-rn-carousel]');
  var storiesSection=root.querySelector('[data-rn-stories]');
  var parallax=root.querySelectorAll('[data-rn-parallax]');
  var ticking=false;

  if(loader&&loaderRings&&!reduced){
    [
      {radius:128,count:36,size:18},
      {radius:176,count:52,size:14},
      {radius:224,count:68,size:10},
      {radius:270,count:84,size:7},
      {radius:314,count:104,size:5}
    ].forEach(function(ring,index){
      var ringElement=document.createElement('div');
      ringElement.className='rn-loader__ring';
      ringElement.style.setProperty('--ring-index',index);
      for(var i=0;i<ring.count;i++){
        var dot=document.createElement('span');
        var angle=(Math.PI*2/ring.count)*i;
        dot.className='rn-loader__dot';
        dot.style.setProperty('--size',ring.size);
        dot.style.left=(Math.cos(angle)*ring.radius)+'px';
        dot.style.top=(Math.sin(angle)*ring.radius)+'px';
        ringElement.appendChild(dot);
      }
      loaderRings.appendChild(ringElement);
    });
  }

  if(loader){
    var delay=function(milliseconds){return new Promise(function(resolve){window.setTimeout(resolve,milliseconds)})};
    var pageReady=document.readyState==='complete'?Promise.resolve():new Promise(function(resolve){window.addEventListener('load',resolve,{once:true})});
    var fontsReady=document.fonts&&document.fonts.ready?document.fonts.ready.catch(function(){}):Promise.resolve();
    var heroReady=!heroVideo||heroVideo.readyState>=2?Promise.resolve():new Promise(function(resolve){
      var finish=function(){heroVideo.removeEventListener('loadeddata',finish);heroVideo.removeEventListener('error',finish);resolve()};
      heroVideo.addEventListener('loadeddata',finish,{once:true});
      heroVideo.addEventListener('error',finish,{once:true});
    });
    Promise.all([delay(1200),pageReady,fontsReady,heroReady]).then(function(){
      loader.classList.add('is-hiding');
      window.setTimeout(function(){loader.remove()},600);
    });
  }

  if(heroVideo){
    var configureHeroVideo=function(){
      heroVideo.muted=true;
      heroVideo.defaultPlaybackRate=1.2;
      heroVideo.playbackRate=1.2;
      if(reduced){
        heroVideo.pause();
        return;
      }
      var playback=heroVideo.play();
      if(playback&&playback.catch)playback.catch(function(){});
    };
    heroVideo.addEventListener('loadedmetadata',configureHeroVideo,{once:true});
    configureHeroVideo();
  }

  if(carousel){
    var track=carousel.querySelector('[data-rn-carousel-track]');
    var slides=[].slice.call(carousel.querySelectorAll('.rn-brand-slide'));
    var prev=carousel.querySelector('[data-rn-carousel-prev]');
    var next=carousel.querySelector('[data-rn-carousel-next]');
    var current=0;
    var carouselActive=false;
    var carouselTimer=null;
    var carouselStarted=false;
    var setCarousel=function(index){
      if(!track||!slides.length)return;
      current=(index+slides.length)%slides.length;
      var slide=slides[current];
      var offset=slide.offsetLeft-(carousel.clientWidth-slide.clientWidth)/2;
      track.style.transform='translate3d('+(-Math.max(0,offset))+'px,0,0)';
      slides.forEach(function(item,slideIndex){item.classList.toggle('is-active',slideIndex===current)});
    };
    if(prev)prev.addEventListener('click',function(){setCarousel(current-1)});
    if(next)next.addEventListener('click',function(){setCarousel(current+1)});
    window.addEventListener('resize',function(){setCarousel(current)},{passive:true});
    window.setTimeout(function(){setCarousel(0)},80);
    var startCarousel=function(){
      if(reduced||carouselTimer)return;
      if(!carouselStarted){
        carouselStarted=true;
        window.setTimeout(function(){if(carouselActive)setCarousel(current+1)},700);
      }
      carouselTimer=window.setInterval(function(){if(carouselActive)setCarousel(current+1)},5200);
    };
    var updateCarouselVisibility=function(){
      var rect=carousel.getBoundingClientRect();
      var visible=rect.top<window.innerHeight*.78&&rect.bottom>window.innerHeight*.22;
      carouselActive=visible;
      if(visible)startCarousel();
    };
    var carouselObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        carouselActive=entry.isIntersecting;
        if(carouselActive)startCarousel();
      });
    },{threshold:.38});
    carouselObserver.observe(carousel);
    window.addEventListener('scroll',updateCarouselVisibility,{passive:true});
    window.addEventListener('resize',updateCarouselVisibility,{passive:true});
    updateCarouselVisibility();
  }

  if(storiesSection){
    var stories=storiesSection.querySelector('.rn-stories');
    var storiesTrack=storiesSection.querySelector('[data-rn-stories-track]');
    var storySlides=[].slice.call(storiesSection.querySelectorAll('[data-rn-story]'));
    var storyProgress=[].slice.call(storiesSection.querySelectorAll('.rn-stories__progress>span'));
    var storyPrev=storiesSection.querySelector('[data-rn-stories-prev]');
    var storyNext=storiesSection.querySelector('[data-rn-stories-next]');
    var storyToggle=storiesSection.querySelector('[data-rn-stories-toggle]');
    var storyCurrent=0;
    var storyTimer=null;
    var storyVisible=false;
    var storyPaused=false;
    var storyStartX=null;
    var clearStoryTimer=function(){
      if(storyTimer){window.clearTimeout(storyTimer);storyTimer=null;}
    };
    var paintStoryProgress=function(){
      storyProgress.forEach(function(item,index){
        item.classList.toggle('is-complete',index<storyCurrent);
        item.classList.toggle('is-current',index===storyCurrent);
      });
    };
    var scheduleStory=function(){
      clearStoryTimer();
      stories.classList.remove('is-playing');
      paintStoryProgress();
      if(!storyVisible||storyPaused||reduced)return;
      void stories.offsetWidth;
      stories.classList.add('is-playing');
      storyTimer=window.setTimeout(function(){setStory(storyCurrent+1,true)},5500);
    };
    var setStory=function(index,autoplay){
      if(!storySlides.length)return;
      storyCurrent=(index+storySlides.length)%storySlides.length;
      storiesTrack.style.transform='translate3d('+(-storyCurrent*100)+'%,0,0)';
      storySlides.forEach(function(slide,slideIndex){
        var active=slideIndex===storyCurrent;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
      });
      if(autoplay)scheduleStory();else paintStoryProgress();
    };
    var changeStory=function(direction){
      storyPaused=false;
      stories.classList.remove('is-paused');
      storyToggle.setAttribute('aria-pressed','false');
      storyToggle.setAttribute('aria-label','Pause stories');
      setStory(storyCurrent+direction,true);
    };
    storyPrev.addEventListener('click',function(){changeStory(-1)});
    storyNext.addEventListener('click',function(){changeStory(1)});
    storyToggle.addEventListener('click',function(){
      storyPaused=!storyPaused;
      stories.classList.toggle('is-paused',storyPaused);
      storyToggle.setAttribute('aria-pressed',String(storyPaused));
      storyToggle.setAttribute('aria-label',storyPaused?'Play stories':'Pause stories');
      if(storyPaused)clearStoryTimer();else scheduleStory();
    });
    stories.addEventListener('keydown',function(event){
      if(event.key==='ArrowLeft'){event.preventDefault();changeStory(-1);}
      if(event.key==='ArrowRight'){event.preventDefault();changeStory(1);}
      if(event.key===' '){event.preventDefault();storyToggle.click();}
    });
    stories.addEventListener('pointerdown',function(event){storyStartX=event.clientX});
    stories.addEventListener('pointerup',function(event){
      if(storyStartX===null)return;
      var distance=event.clientX-storyStartX;
      storyStartX=null;
      if(Math.abs(distance)>55)changeStory(distance>0?-1:1);
    });
    var storyObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        storyVisible=entry.isIntersecting;
        if(storyVisible&&!storyPaused)scheduleStory();
        if(!storyVisible){clearStoryTimer();stories.classList.remove('is-playing');}
      });
    },{threshold:.42});
    storyObserver.observe(stories);
    setStory(0,false);
  }

  function setMenu(open){
    menu.classList.toggle('is-open',open);
    menu.setAttribute('aria-hidden',String(!open));
    openButton.setAttribute('aria-expanded',String(open));
    document.documentElement.style.overflow=open?'hidden':'';
    if(open){
      menuLastFocus=document.activeElement;
      closeButton.focus();
    }else if(menuLastFocus&&typeof menuLastFocus.focus==='function'){
      menuLastFocus.focus();
    }
  }
  openButton.addEventListener('click',function(){setMenu(true)});
  closeButton.addEventListener('click',function(){setMenu(false)});
  menu.addEventListener('click',function(event){if(event.target.closest('a'))setMenu(false)});
  document.addEventListener('keydown',function(event){
    if(!menu.classList.contains('is-open'))return;
    if(event.key==='Escape'){
      setMenu(false);
      return;
    }
    if(event.key!=='Tab')return;
    var focusable=[].slice.call(menu.querySelectorAll('a[href],button:not([disabled])'));
    if(!focusable.length)return;
    var first=focusable[0];
    var last=focusable[focusable.length-1];
    if(event.shiftKey&&document.activeElement===first){
      event.preventDefault();
      last.focus();
    }else if(!event.shiftKey&&document.activeElement===last){
      event.preventDefault();
      first.focus();
    }
  });

  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting)return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  },{rootMargin:'0px 0px -12% 0px',threshold:.08});
  root.querySelectorAll('[data-rn-reveal]').forEach(function(element){
    if(reduced)element.classList.add('is-visible');else observer.observe(element);
  });

  function update(){
    var top=window.scrollY||document.documentElement.scrollTop;
    var range=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
    nav.classList.toggle('is-scrolled',top>28);
    if(progress)progress.style.transform='scaleX('+Math.min(1,top/range)+')';
    if(!reduced){
      if(heroImage&&top<window.innerHeight*1.2)heroImage.style.transform='translate3d(0,'+(top*.11)+'px,0) scale(1)';
      parallax.forEach(function(image){
        var rect=image.parentElement.getBoundingClientRect();
        if(rect.bottom<0||rect.top>window.innerHeight)return;
        var offset=(rect.top+rect.height/2-window.innerHeight/2)*-.08;
        image.style.transform='translate3d(0,'+offset+'px,0)';
      });
    }
    ticking=false;
  }
  function requestUpdate(){if(ticking)return;ticking=true;window.requestAnimationFrame(update)}
  window.addEventListener('scroll',requestUpdate,{passive:true});
  window.addEventListener('resize',requestUpdate,{passive:true});
  update();
})();

(() => {
  const root = document.querySelector('[data-rn-home]');
  if (!root || root.dataset.rnCommerceReady) return;
  root.dataset.rnCommerceReady = 'true';
  const lang = document.documentElement.lang.split('-')[0];
  const rtl = lang === 'ar' || lang === 'he';
  if (rtl) document.documentElement.dir = 'rtl';
  const text = {
    added: lang === 'ar' ? 'تمت الإضافة إلى حقيبتك' : lang === 'he' ? 'נוסף לתיק הקניות' : 'Added to your bag',
    error: lang === 'ar' ? 'تعذر الإضافة. حاول مرة أخرى.' : lang === 'he' ? 'לא ניתן להוסיף כרגע. נסו שוב.' : 'Could not add this item. Please try again.',
    pause: lang === 'ar' ? 'إيقاف مؤقت' : lang === 'he' ? 'השהיה' : 'Pause film',
    play: lang === 'ar' ? 'تشغيل' : lang === 'he' ? 'הפעלה' : 'Play film',
    soundOn: lang === 'ar' ? 'الصوت يعمل' : lang === 'he' ? 'עם קול' : 'Sound on',
    soundOff: lang === 'ar' ? 'الصوت متوقف' : lang === 'he' ? 'ללא קול' : 'Sound off'
  };
  const base = window.Shopify?.routes?.root || '/';
  const notice = root.querySelector('[data-rn-bag-notice]');
  let noticeTimer;
  function message(value, error = false) {
    if (!notice) return;
    notice.querySelector('[data-rn-bag-message]').textContent = value;
    notice.classList.toggle('is-error', error);
    notice.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(() => { notice.hidden = true; }, error ? 12000 : 6500);
  }
  notice?.querySelector('[data-rn-bag-dismiss]')?.addEventListener('click', () => { notice.hidden = true; });
  root.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add\/?$/.test(new URL(form.action).pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.rnPending === 'true') return;
    const button = event.submitter || form.querySelector('button[type="submit"]');
    form.dataset.rnPending = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    try {
      const body = new FormData(form);
      body.delete('return_to');
      const response = await fetch(base + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || text.error);
      const cartResponse = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error(text.error);
      const cart = await cartResponse.json();
      root.querySelectorAll('[data-rn-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      root.dispatchEvent(new CustomEvent('rn:open-bag', {detail: cart}));
      document.dispatchEvent(new CustomEvent('rn:cart-updated', { detail: cart }));
    } catch (error) {
      message(error.message || text.error, true);
    } finally {
      form.dataset.rnPending = 'false';
      form.removeAttribute('aria-busy');
      if (button) button.disabled = false;
    }
  }, true);

  const hero = root.querySelector('[data-rn-hero-film]');
  const heroToggle = root.querySelector('[data-rn-hero-toggle]');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection?.saveData;
  function loadVideo(video) {
    if (!video.src && video.dataset.src) { video.src = video.dataset.src; video.load(); }
  }
  function play(video) { loadVideo(video); video.play()?.catch(() => {}); }
  if (hero) {
    let userPaused = reduceMotion || saveData;
    const paint = () => {
      if (!heroToggle) return;
      heroToggle.textContent = hero.paused ? text.play : text.pause;
      heroToggle.setAttribute('aria-label', heroToggle.textContent);
      heroToggle.setAttribute('aria-pressed', String(hero.paused));
    };
    hero.addEventListener('play', paint);
    hero.addEventListener('pause', paint);
    heroToggle?.addEventListener('click', () => { userPaused = !hero.paused; if (hero.paused) play(hero); else hero.pause(); paint(); });
    const start = () => { if (!userPaused) play(hero); paint(); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !userPaused) play(hero); else hero.pause();
    }, { threshold: .2 }).observe(hero);
    document.addEventListener('visibilitychange', () => { if (document.hidden) hero.pause(); });
  }

  root.querySelectorAll('[data-rn-shop-films]').forEach(section => {
    const track = section.querySelector('[data-rn-film-track]');
    const cards = [...section.querySelectorAll('[data-rn-film-card]')];
    const sound = section.querySelector('[data-rn-film-sound]');
    let index = 0, visible = false, muted = true, userPaused = false, timer;
    const currentVideo = () => cards[index]?.querySelector('video');
    const paint = () => {
      cards.forEach((card, i) => {
        const video = card.querySelector('video');
        card.classList.toggle('is-active', i === index);
        video.muted = muted;
        if (i === index && visible && !userPaused && !reduceMotion && !saveData) play(video); else video.pause();
        card.querySelector('[data-rn-film-play]').textContent = video.paused ? '▶' : 'Ⅱ';
      });
      section.querySelector('[data-rn-film-index]').textContent = `${index + 1} / ${cards.length}`;
      sound.textContent = muted ? text.soundOff : text.soundOn;
      sound.setAttribute('aria-pressed', String(!muted));
    };
    const set = next => {
      index = (next + cards.length) % cards.length;
      userPaused = false;
      const rect = cards[index].getBoundingClientRect();
      const container = track.getBoundingClientRect();
      track.scrollBy({ left: rect.left + rect.width / 2 - container.left - container.width / 2, behavior: reduceMotion ? 'instant' : 'smooth' });
      paint();
    };
    section.querySelector('[data-rn-film-prev]').addEventListener('click', () => set(index - 1));
    section.querySelector('[data-rn-film-next]').addEventListener('click', () => set(index + 1));
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight') { event.preventDefault(); set(index + (rtl ? -1 : 1)); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); set(index + (rtl ? 1 : -1)); }
    });
    track.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const rect = track.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        index = cards.reduce((best, card, i) => {
          const r = card.getBoundingClientRect(), b = cards[best].getBoundingClientRect();
          return Math.abs(r.left + r.width / 2 - center) < Math.abs(b.left + b.width / 2 - center) ? i : best;
        }, index);
        userPaused = false;
        paint();
      }, 120);
    }, { passive: true });
    cards.forEach((card, i) => {
      const video = card.querySelector('video');
      card.querySelector('[data-rn-film-play]').addEventListener('click', () => {
        if (i !== index) set(i);
        userPaused = !video.paused;
        if (video.paused) { loadVideo(video); video.play()?.catch(() => {}); } else video.pause();
      });
      video.addEventListener('play', () => { card.querySelector('[data-rn-film-play]').textContent = 'Ⅱ'; });
      video.addEventListener('pause', () => { card.querySelector('[data-rn-film-play]').textContent = '▶'; });
      video.addEventListener('ended', () => set(index + 1));
    });
    sound.addEventListener('click', () => { muted = !muted; if (currentVideo()) currentVideo().muted = muted; paint(); });
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; paint(); }, { threshold: .2 }).observe(section);
    document.addEventListener('visibilitychange', () => { if (document.hidden) cards.forEach(card => card.querySelector('video').pause()); });
    paint();
  });

  const forms = [...root.querySelectorAll('.rn-region__form')];
  forms.forEach(form => form.addEventListener('submit', () => { try { localStorage.setItem('rn_market_manual', 'true'); } catch {} }));
  async function detectMarket() {
    if (window.Shopify?.designMode || /bot|crawl|spider/i.test(navigator.userAgent) || !forms.length) return;
    try {
      if (localStorage.getItem('rn_market_manual') || sessionStorage.getItem('rn_market_detected')) return;
      sessionStorage.setItem('rn_market_detected', 'true');
      const response = await fetch(base + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const result = await response.json();
      const suggested = result.suggestions?.[0]?.parts?.country?.handle;
      const form = forms[0], select = form.elements.country_code;
      if (!suggested || suggested === select.value || ![...select.options].some(option => option.value === suggested)) return;
      select.value = suggested;
      form.submit();
    } catch {}
  }
  if (document.readyState === 'complete') detectMarket(); else window.addEventListener('load', detectMarket, { once: true });
})();

(() => {
 const root=document.querySelector('[data-rn-home]');
 if(!root || root.dataset.rnDrawersReady)return;
 root.dataset.rnDrawersReady='true';
 const lang=document.documentElement.lang.split('-')[0], base=window.Shopify?.routes?.root || '/';
 const tr=(en,ar,he)=>lang==='ar'?ar:lang==='he'?he:en;
 const cartDrawer=root.querySelector('[data-rn-cart-drawer]'), wishDrawer=root.querySelector('[data-rn-wishlist-drawer]');
 let currency=window.Shopify?.currency?.active || 'AED', saved=[],lastFocus;
 try{saved=JSON.parse(localStorage.getItem('rn_wishlist_v1')||'[]').filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h));}catch{}
 const money=cents=>new Intl.NumberFormat(lang,{style:'currency',currency}).format(cents/100);
 function el(tag,cls,text){const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;}
 function close(d){d.close();document.documentElement.classList.remove('rn-dialog-open');lastFocus?.focus();}
 function open(d){if(!d)return; lastFocus=document.activeElement;[cartDrawer,wishDrawer].forEach(x=>{if(x?.open)x.close();}); if(!d.open)d.showModal();document.documentElement.classList.add('rn-dialog-open');d.querySelector('button')?.focus();}
 [cartDrawer,wishDrawer].filter(Boolean).forEach(d=>{
  d.querySelectorAll('[data-rn-drawer-close]').forEach(b=>b.addEventListener('click',()=>close(d)));
  d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)close(d);}});
  d.addEventListener('close',()=>document.documentElement.classList.remove('rn-dialog-open'));
 });
 root.querySelectorAll('[data-rn-country-flag]').forEach(n=>{const iso=n.dataset.rnCountryFlag;if(/^[A-Z]{2}$/.test(iso))n.textContent=String.fromCodePoint(...[...iso].map(c=>127397+c.charCodeAt(0)));});
 function paintWish(){root.querySelectorAll('[data-rn-wish]').forEach(b=>{const on=saved.includes(b.dataset.rnWish);b.setAttribute('aria-pressed',String(on));b.classList.toggle('is-saved',on);b.setAttribute('aria-label',(on?tr('Remove from wishlist','إزالة من المفضلة','הסרה מהמועדפים'):tr('Save to wishlist','أضف إلى المفضلة','שמירה במועדפים'))+' '+b.dataset.rnWish);});root.querySelectorAll('[data-rn-wish-count]').forEach(n=>{n.textContent=saved.length;n.hidden=!saved.length;});}
 function saveWish(){try{localStorage.setItem('rn_wishlist_v1',JSON.stringify(saved));}catch{}paintWish();}
 const wishItems=root.querySelector('[data-rn-wishlist-items]');
 async function paintWishDrawer(){
  wishItems.replaceChildren(el('p','rn-drawer__message',tr('Loading…','جارٍ التحميل…','טוען…')));
  if(!saved.length){wishItems.replaceChildren(el('p','rn-drawer__message',tr('Keep the fragrances you love here. Tap a heart to begin.','احتفظ بالعطور التي تحبها هنا. اضغط على القلب للبدء.','שמרו כאן את הבשמים שאתם אוהבים. לחצו על לב כדי להתחיל.')));return;}
  const products=await Promise.all(saved.map(async h=>{try{const response=await fetch(base+'products/'+encodeURIComponent(h)+'.js');return response.ok?await response.json():null;}catch{return null;}}));
  wishItems.replaceChildren();
  products.forEach(p=>{if(!p)return;const row=el('article','rn-drawer-item');const a=el('a','rn-drawer-item__image');a.href=base+'products/'+p.handle;const img=el('img');img.src=p.featured_image;img.alt=p.title;img.loading='lazy';a.append(img);const body=el('div','rn-drawer-item__body');const title=el('a','rn-drawer-item__title',p.title);title.href=a.href;body.append(title,el('p','',money(p.price)));const remove=el('button','rn-drawer-item__remove',tr('Remove','إزالة','הסרה'));remove.type='button';remove.addEventListener('click',()=>{saved=saved.filter(h=>h!==p.handle);saveWish();paintWishDrawer();});const view=el('a','rn-drawer-item__explore',tr('Discover fragrance ↗','اكتشف العطر ↗','לגלות את הבושם ↗'));view.href=a.href;body.append(view,remove);row.append(a,body);wishItems.append(row);});
 }
 root.addEventListener('click',e=>{
  const b=e.target.closest('[data-rn-wish]');if(b){e.preventDefault();const h=b.dataset.rnWish;saved=saved.includes(h)?saved.filter(x=>x!==h):[...saved,h];saveWish();return;}
  if(e.target.closest('[data-rn-wishlist-open]')){e.preventDefault();root.querySelector('[data-rn-menu-close]')?.click();open(wishDrawer);paintWishDrawer();}
  const bag=e.target.closest('[data-rn-bag-open]');if(bag){e.preventDefault();open(cartDrawer);refreshCart();}
 });
 const cartItems=root.querySelector('[data-rn-drawer-items]');let updating=false;
 async function refreshCart(){try{const response=await fetch(base+'cart.js',{cache:'no-store'});if(!response.ok)throw Error();renderCart(await response.json());}catch{cartItems.replaceChildren(el('p','rn-drawer__message',tr('Unable to load your bag. Please try again.','تعذر تحميل الحقيبة. حاول مرة أخرى.','לא ניתן לטעון את התיק. נסו שוב.')));}}
 async function change(key,quantity){if(updating)return;updating=true;cartDrawer.setAttribute('aria-busy','true');try{const response=await fetch(base+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});const data=await response.json();if(!response.ok)throw Error(data.description||tr('Could not update your bag.','تعذر تحديث الحقيبة.','לא ניתן לעדכן את התיק.'));renderCart(data);}catch(error){const status=el('p','rn-drawer__message',error.message);status.setAttribute('role','alert');cartItems.prepend(status);}finally{updating=false;cartDrawer.removeAttribute('aria-busy');}}
 function renderCart(cart){
  currency=cart.currency||currency;cartItems.replaceChildren();root.querySelectorAll('[data-rn-cart-count]').forEach(n=>n.textContent=cart.item_count);
  root.querySelector('[data-rn-drawer-total]').textContent=money(cart.total_price);
  root.querySelector('.rn-drawer__summary').hidden=!cart.item_count;
  if(!cart.item_count){cartItems.append(el('p','rn-drawer__message',tr('Your next signature starts here. Your bag is empty.','توقيعك القادم يبدأ هنا. حقيبتك فارغة.','הניחוח הבא שלך מתחיל כאן. התיק ריק.')));const link=el('a','rn-drawer__checkout',tr('Discover the collection','اكتشف المجموعة','לגלות את הקולקציה'));link.href=base+'collections/all';cartItems.append(link);return;}
  cart.items.forEach(item=>{const row=el('article','rn-drawer-item');const a=el('a','rn-drawer-item__image');a.href=item.url;const img=el('img');if(item.image)img.src=item.image;img.alt=item.product_title;img.loading='lazy';a.append(img);const body=el('div','rn-drawer-item__body');const title=el('a','rn-drawer-item__title',item.product_title);title.href=item.url;body.append(title);if(item.variant_title)body.append(el('p','rn-drawer-item__variant',item.variant_title));body.append(el('p','rn-drawer-item__price',money(item.final_line_price)));const quantity=el('div','rn-drawer-item__quantity');const minus=el('button','','−'),plus=el('button','','+');minus.type=plus.type='button';minus.setAttribute('aria-label',tr('Decrease quantity','تقليل الكمية','הקטנת כמות')+' '+item.product_title);plus.setAttribute('aria-label',tr('Increase quantity','زيادة الكمية','הגדלת כמות')+' '+item.product_title);minus.addEventListener('click',()=>change(item.key,item.quantity-1));plus.addEventListener('click',()=>change(item.key,item.quantity+1));quantity.append(minus,el('span','',item.quantity),plus);const remove=el('button','rn-drawer-item__remove',tr('Remove','إزالة','הסרה'));remove.type='button';remove.addEventListener('click',()=>change(item.key,0));body.append(quantity,remove);row.append(a,body);cartItems.append(row);});
 }
 root.addEventListener('rn:open-bag',e=>{renderCart(e.detail);open(cartDrawer);});
 paintWish();
 const hero=root.querySelector('.rn-atelier__hero');
 if(hero){const update=()=>root.classList.toggle('rn-hero-covered',hero.getBoundingClientRect().bottom<=0);window.addEventListener('scroll',update,{passive:true});update();}
})();
